<template>
    <div id="canvas" v-if="loggedIn" class="gift-choice-page" :class="isBundle ? 'bundle' : ''">
      <div id="mContainer" class="main-container no-scrollbar">
        <img v-if="collectionImage" :src="collectionImage.src" class="custom-header desktop" width="1920px"/>
        <img v-if="collectionImage" :src="collectionImage.alt" class="custom-header mobile" width="1920px"/>
        <p v-if="!collectionImage" class="main-title">Time to Pick Your Gift!</p>
        <p v-if="!collectionImage" class="main-subtitle">You can pick one or many gifts to hit the value your sender has selected. Go ahead, have fun.</p>
        <div id="tabs" class="tabs" :class="[isSticking ? 'sticky' : '',showTicker ? 'hasTicker' : '']">
          <div class="tab" :class="[(selectedTab == tab.value || (!selectedTab && i == 0)) ? 'selected' : '',(isBundle && tab.value > 0 && tabs[tab.value - 1].currentQty > 0) ? 'disabled' : '']" v-for="(tab,i) in tabs">
            <div @click="selectTab(tab.value)" class="happybox-button light-gray border">
              <span v-if="isBundle">Step {{ i+1 }}:&nbsp;</span>
              <span>Pick {{ tab.currentQty }} {{ tab.maxQty > 1 ? "gifts" : "gift" }}</span>
              <p class="arrow down"></p>
            </div>
          </div>
        </div>
        <div class="products-listing">
          <p class="capacity-overlay" v-if="maxProductsToAdd == 0">100% full! Proceed to the next step <br class="mobile"/> or remove items to keep shopping.</p>
          <p class="bundle-instructions" v-html="bundleInstructions" v-if="bundleInstructions && maxProductsToAdd != 0">
          </p>
          <div class="products-inner-container" :class="maxProductsToAdd == 0 ? 'disabled' : ''">
            <div v-for="product in filteredProducts" :key="product.id" class="product-container" :class="cartProducts.find(x => x.id == product.id) ? 'selected' : ''">
              <img @click="removeProduct(product)" class="circle remove"  src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x">
              <div @click="selectProduct(product)" class="product-image-container" >
                <span v-if="mainBadge(product) != null" class="main-badge">{{ mainBadge(product) }}</span>
                <img class="info mobile" src="https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_9b78e5b1-b9be-49ca-826c-b3734c2991c5.svg?v=1683232689"/>
                <div class="loading">
                  <img class="lazyload main-image" width="150" height="150" :src="product.images[0].src"/>
                </div>
                <img v-if="product.images.length > 1" :src="product.images[1].src" class="hover-image" />
              </div>
              <p class="product-title">{{ product.title }}</p>
            </div>
          </div>
        </div>
      </div>
      <SideCart 
        :capacity="percentageFilledCapacity" 
        :selectedProducts="cartProducts" 
        :maxProductsToAdd="maxProductsToAdd"
        :isLoading="isLoading"
        :isBundle="isBundle"
        :tabs="tabs"
        @removeproduct="removeProduct($event)"
        @openmodal="openModal($event)"
      />
      <ProductModal 
        v-if="selectedProduct" 
        :collectionValue="collectionValue"
        :availableCapacity="availableCapacity"
        :product="selectedProduct" 
        :cartProducts="cartProducts"
        :isLoading="isLoading"
        :isBundle="isBundle"
        :tabs="tabs"
        @closemodal="closeModal" 
        @selectproduct="addProduct($event)" 
        @cleanadd="cleanAdd($event)"

        @nextstep="nextStep()"
      />
    </div>
    <div v-else class="spinner-container" :class="reclaimed ? 'top' : ''">
      <p v-if="invalidToken">Invalid Access</p>
      <div class="reclaimed-container" v-else-if="reclaimed">
        <p class="title">
          <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"/>
          <span>Great Choice</span>
          <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"/>
        </p>
        <p class="subtitle">You'll receive updates and tracking info via email!</p>
      </div>
      <div v-else class="loading-container">
        <p>
        If you are having trouble loading this page, please turn off your VPN or company wifi. <br class="desktop"/> Due to IT security restrictions, you may need to open the link on a personal device or forward the email to a personal email address to redeem your gift.<br class="desktop"/>
        If you are still having issues, please reach out to <a href="mailto:orders@happyboxstore.com">orders@happyboxstore.com</a> for immediate assistance.
      </p>
        <div class="spinner"></div>
      </div>
    </div>
  </template>
  
  <script>
  import confetti from "canvas-confetti";
  import axios from "axios";
  import ProductModal from "./ProductModal.vue";
  import SideCart from "./SideCart.vue";
  export default {
      data(){
          return {
              products: [],
              bundles: [],
              isBundle: false,
              selectedProduct: null,
              cartProducts: [],
              loggedIn: false,
              giftToken: null,
              invalidToken: null,
              isLoading: false,
              reclaimed: false,
              collectionImage: null,
              steps: ["PICK YOUR GIFT","ADD YOUR ADDRESS"],
              extraProperties: [],
              selectedTab: null,
              collectionCapacity: 0,
              isSticking: false,
              showTicker:false,
              x:0,
              y:0,
          }
      },
      components: {
        SideCart,
        ProductModal
      },
      props:{
        collection: Object,
      },
      computed:{
        tabs(){
          if(this.isBundle){
            let values = this.bundles.map((x,i) =>{return {maxQty: x.qty,value:i,currentQty:x.qty - this.bundleAvailableCapacity[i] }})
            values.sort((a,b) => a.value - b.value);
            return values;
          }
          else if(this.products && this.products.length > 0 && this.collectionValue){
            let values = this.products.map((x) => {
              let tags = x.tags;
              let value = tags.find(y => y.toLowerCase().includes("goc_capacity_"))
              if(value){
                value = value.split("_")[2];
  
                return parseInt(value);
              }
  
              return 0;
            })
            
            values = [...new Set(values.filter(x => x > 0))].map(x => {return {maxQty: Math.floor(this.collectionValue / x),value:x,currentQty:Math.floor(this.availableCapacity / x)}});
            values.sort((a,b) => b.value - a.value);
            return values;
          }
  
          return [];
        },
        collectionValue(){
          return this.collectionCapacity;
        },
        filteredProducts(){
          if(this.tabs){
            let currentTab = this.selectedTab ? this.selectedTab : this.tabs[0].value;
            let products = this.isBundle ?  this.bundles[currentTab].products : this.products.filter(x => x.tags.includes(`GOC_Capacity_${currentTab}`));
            let tab = this.tabs.find(x => x.value == currentTab);
            if(this.tabs.length > 1 || (this.tabs.length == 1 && tab.maxQty > 1) || this.isBundle){
              products = products.filter(x => !x.tags.includes("Dropship"));
            }
  
            return products
          }
  
          return [];
        },
        filledCapacity(){
          if(this.cartProducts && this.cartProducts.length > 0 && this.collectionValue){
            let values = this.cartProducts.map((x) => {
                let tags = x.tags;
                let value = tags.find(y => y.toLowerCase().includes("goc_capacity_"))
                if(value){
                value = value.split("_")[2];
  
                return parseInt(value) * x.qty;
                }
  
                return 0;
            })
            return values.reduce((partialSum,a) => partialSum + a,0);
          }
          return 0;
        },
        percentageFilledCapacity(){
          if(this.isBundle){
            return  Math.round((this.bundleAvailableCapacity.reduce((prev,number) => prev + number,0) * 100) / this.tabs.reduce((prev,tab) => prev + tab.maxQty,0));
          }
          else
            return Math.round((this.filledCapacity * 100) / this.collectionValue);
        },
        bundleAvailableCapacity(){
          if(this.isBundle){
            return this.bundles.map((x,i) =>{
              let products = this.cartProducts.filter(x => x.tab == i);
              return products.reduce((prev,product) => prev + product.qty,0);
            })
          }
        },
        availableCapacity(){
          return this.collectionValue - this.filledCapacity;
        },
        maxProductsToAdd(){
          if(this.tabs && this.tabs.length > 0){
            if(this.isBundle){
              return this.tabs.reduce((sum,x) => sum + x.currentQty,0);
            }
            else{
              let tabValues = this.tabs.map(x => x.value);
              return Math.floor( (this.availableCapacity) / Math.min(...tabValues));
            }
          }
  
          return 0
        },
        bundleInstructions(){
          if (this.isBundle){
            if(this.tabs[0].currentQty != 0){
              return "<p>It's time to pick your holiday gift! You'll be prompted to pick out 2 total gifts.</p> <p><strong>Select your first gift:</strong></p>";
            }
            else {
              return `<p>It's time to pick your holiday gift! You'll be prompted to pick out 2 total gifts.</p><p><strong>Great choice! Select your second gift.</strong></p>`;
            }
          }

          return null;
        },
      },
      methods:{
        selectProduct(product){
          this.selectedProduct = product;
        },
        closeModal(){
          this.selectedProduct = null;
        },
        addProduct(event){
          let variantId = event.variants[0].id;
          let i = this.cartProducts.findIndex(x => x.variants.find(y => y.id == variantId));
          if(i < 0){
            confetti({origin:{
              x: this.x
              ,y: this.y
            }});
            this.cartProducts.push(event);
          }
          else {
            Vue.set(this.cartProducts[i],"qty",event.qty)
          }
        },
        cleanAdd(event){
          if(this.isBundle){
            this.cartProducts = this.cartProducts.filter(x => x.tab != event.tab);
          }
          else
            this.cartProducts = [];
          this.addProduct(event);
        },
        removeProduct(product){
          let variantId = product.variants[0].id;
          let i = this.cartProducts.findIndex(x => x => x.variants.find(y => y.id == variantId));
          if(i > -1){
            this.cartProducts.splice(i,1);
          }
        },
        mainBadge(product){
          let splitTags = product.tags;
            var tags =  splitTags.filter(y => y.includes("Tag_"));
            if(tags.length > 0){
              tags = tags.map((x) => {
                var currentTag = x.replace("Tag_","").replace("Tag_","");
                return currentTag;
              })
  
              return tags[0];
            }
  
            var ethos = splitTags.filter(y => y.includes("Filter_Ethos"));
            if(ethos.length > 0){
              ethos = ethos.map((x) => {
                var currentEthos = x.replace("Filter_","").split("_")
                return currentEthos[1]
              })
  
              return ethos[0];
            }
  
            return null
            
          },
          openModal(product){
            let selected = this.products.find(x => x.id == product.id);
            if(selected){
              this.selectedProduct = selected;
            }
          },
          async login(){
            let metafields = await axios.get(`/collections/${this.collection.body_html}?view=metafields`);
              if(metafields.data && metafields.data.metafields){
                metafields = metafields.data.metafields;
                if(metafields.value && metafields.value > 0)
                this.collectionCapacity = metafields.value;
              }
              this.products = this.collection.collectionProducts.map((x) => {
                x.variants = x.variants.filter(y => y.price == "0.00").map((y) => {
                    y.inventory_quantity = 999;
                  return y
                })

                return x
              })
              this.loggedIn = true;

              await this.$nextTick(() => {});
              let canvas = document.getElementById('canvas');
              if(window.matchMedia("(pointer: coarse)").matches) {
                canvas.addEventListener('touchend', this.onTouchEnd, false);
              }
              else{
                canvas.addEventListener('mousemove', this.onMouseMove, false);
              }
              var that = this;
              var element = document.getElementById("tabs");
              var observer = new IntersectionObserver(function(entries) {
                  if(entries[0].intersectionRatio < 1){
                    that.isSticking = true;
                  }
                  else{
                    that.isSticking = false;
                  }
              }, { threshold: [0,1] });

              observer.observe(element);
          },
          onMouseMove(e){
            this.x = e.clientX / window.innerWidth;
            this.y = e.clientY / window.innerHeight;
          },
          onTouchEnd(e){
            if(e.changedTouches.length > 0){
              this.x = e.changedTouches[0].clientX / window.innerWidth;
              this.y = e.changedTouches[0].clientY / window.innerHeight;
            }
          },
          selectTab(value){
            if(this.isBundle){
              let tab = this.tabs.find(x => x.value == value);
              if(tab.currentQty == 0 || tab.value == 0 || this.tabs[value - 1].currentQty == 0)
                this.selectedTab = value;
            }
            else
              this.selectedTab = value;
          },
          nextStep(){
            this.selectTab(this.selectedTab + 1);
          }
      },
      mounted(){
        this.login();
      },
  }
  </script>
  
  <style>
      #attentive_overlay{
        display: none;
      }
  
      .gift-choice-page p,.gift-choice-page span{
        color: #0F0C38;
        margin: 0;
      }
  
      .desktop-flex{
          display: flex !important;
      }
  
      .desktop{
          display: block !important;
      }
  
      .mobile{
          display: none !important;
      }
  
      @media only screen and (max-device-width: 767px){
        .desktop-flex{
          display: none !important;
        }
  
        .desktop{
          display: none !important;
        }
  
        .mobile{
          display: block !important;
        }
      }
      </style>
  
  
  
      <style scoped>
      .wiggle{
          width: 100%;
          overflow: hidden;
          position: relative;
      }
  
      .wiggle img{
          width: 120%;
          height: 100%;
          position: relative;
          left: -10%;
      }
  
      .gift-choice-page{
        width: 100%;
        display: flex;
        height: 100%;
      }
  
      .gift-choice-page .header.custom img{
        padding: unset;
        width: 100%;
      }
  
      .gift-choice-page .header{
        background-color: #f2f6ff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
  
      .gift-choice-page .header img{
        width: 23%;
        padding: 2% 0%;
      }
  
    .wiggle.white{
          background: linear-gradient(0deg, white 40%, #eee6ff 60%);
      }
  
    .happybox-button.orange{
      padding: 1% 10%;
      font-size: 1.5vw;
      border: 1px solid #d9bd47;
    }
  
    .gift-choice-page .main-container{
      text-align: center;
      width: 100%;
      min-width: 90%;
      height: 100%;
      overflow: auto;
      scroll-behavior: smooth;
      background-color: #f8f9fd;
      padding: unset;
    }
  
    .gift-choice-page .main-container .main-title{
      margin-top: 1%;
      font-size: 4vw;
      font-weight: 500;
      font-family: Founders Grotesk, sans-serif;
    }
  
    .gift-choice-page .main-container .main-subtitle{
      font-size: 1.15vw;
      margin-bottom: 1em;
    }
  
    .next-step{
      font-size: 1.8vw;
      margin: 2% 0%;
    }
  
    .next-step span,.next-step strong{
      font-style: italic;
      font-family: moret,sans-serif;
    }
  
    .main-legend{
      text-align: left;
      font-size: 1.6vw;
      padding-bottom: 5%;
    }
  
    .products-listing{
      width: 100%;
      padding: 2% 10% 2% 5%;
      min-height: 40vh;
      background-color: #f8f9fd;
      box-shadow: 0px -1px 0px 1px #0000001f;
      position: relative;
    }
  
    .product-container {
      width: 23%;
      background-color: white;
      box-shadow: 0 0 2px #0000004d;
      border-radius: 8px;
      padding: 1%;
      position: relative;
    }
  
    .bundle .product-container{
      width: 30%;
    }
  
    .product-container .loading {
      width: 100%;
      height: auto;
      cursor: pointer;
      position: relative;
    }
    .product-container .loading .main-image{
      z-index: 2;
      background-color: #f6f6f6;
      height: 100%;
      width: 100%;
      position: relative;
      aspect-ratio: 1;
      display: block;
    }
  
    .product-container .loading:before {
      content: "";
      position: absolute;
      z-index: 1;
      top: 0%;
      left: 0%;
      width: 100%;
      padding-bottom: 100%;
      animation: skeleton-loading 1s linear infinite alternate;
    }
  
    .product-container .hover-image {
      background-color: #f6f6f6;
      width: 100%;
      height: 100%;
      object-fit: contain;
      cursor: pointer;
      position: absolute;
      top: 0;
      bottom: 0;
      z-index: 1;
      -webkit-transition: all .35s ease-in-out;
      transition: all .35s ease-in-out;
    }
  
    .product-image-container:hover .hover-image {
      opacity: 1;
    }
  
    .product-container .product-title{
      font-size: 1vw;
      margin: 5% 0%;
      font-weight: bold;
      line-height: 1.2;
    }
  
    .product-image-container{
      display: flex;
      flex-direction: column;
      position: relative;
      width: 100%;
    }
  
    .product-container.selected{
      border: 2px solid #a01adb;
    }
  
    .hover-container {
      display: flex;
      position: absolute;
      width: 100%;
      bottom: -30%;
      margin: unset;
      -webkit-transition: all .35s ease-in-out;
      transition: all .35s ease-in-out;
      background-color: rgba(225,231,253,0.8);
      align-items: center;
      justify-content: center;
      gap: 5px;
      cursor: pointer;
      z-index: 2;
    }
  
    .hover-container img{
      width: 10%;
    }
  
    .hover-container p{
      color: #5A6BA3;
      font-size: 1vw;
      padding: 2% 0%;
      font-weight: bold;
      letter-spacing: 0.2px;
    }
  
    .product-image-container:hover .hover-container{
      bottom: 0%;
    }
  
    .product-container .white{
      border: 1px solid #CFCED8 !important;
    }
  
    .product-container button{
      padding: 4% 9% !important;
    }
  
    .continue-container button{
      border: 1px solid #CFCED8;
      padding: 1% 10%;
    }
  
    .happybox-button.white,.happybox-button.purple,.happybox-button.yellow,.happybox-button.green{
      font-size: 1vw;
      padding: 1% 15%;
    }
  
    .happybox-button.purple:hover{
      background-color: #e6d7fa;
    }
  
    .slick-slider{
      width: 100%;
      margin-bottom: 15px;
    }
  
    .slick-track {
    display: flex!important;
  }
  
  .slick-slide {
    height: inherit!important;
    display: flex!important;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
  
  .slick-slide div{
    width: 100%;
  }
  
  .slick-arrow:before {
    content: ""!important;
  }
  
    .loading-container{
      width: 100%;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  
    .loading-container p{
      font-size: 1.15vw;
      color: #0f0c38;
      font-family: "Karla",sans-serif;
      margin-bottom: 2%;
      text-align: center;
    }
  
    .spinner-container{
      width: 100%;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 70vh;
    }
  
    .spinner-container.top{
      align-items: flex-start;
      padding-top: 5%;
    }
  
    .spinner {
      border: 4px solid rgba(0, 0, 0, 0.3);
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border-left-color: #09f;
      animation: spin 1s ease infinite;
    }
  
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
  
      100% {
        transform: rotate(360deg);
      }
    }
    .reclaimed-container{
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }
  
    .reclaimed-container .title{
      font-size: 6vw;
      font-family: moret,sans-serif;
      font-weight: bold;
      display: flex;
      gap: 30px;
      width: 100%;
      justify-content: center;
    }
  
    .reclaimed-container .title img{
      width: 3%;
    }
  
    .reclaimed-container .subtitle{
      font-size: 3vw;
      font-family: 'moret',sans-serif;
      font-weight: 300;
      width: 35%;
      text-align: center;
      line-height: 1.2;
    }
  
    .gifting-header{
      display: flex;
      align-items: center;
      padding: 2%;
      position: relative;
    }
  
    .tabs{
      width: 100%;
      display: flex;
      padding: 0% 15%;
      justify-content: center;
      position: sticky;
      top: -1px;
      z-index: 3;
    }
  
    .tabs.sticky{
      padding-top: 1px;
    }
  
    .tabs .tab{
      width: 30%;
      padding: 2%;
      z-index: 1;
    }
  
    .tabs .tab.disabled{
      opacity: 0.8;
    }
  
    .tabs .selected{
      background-color: #f8f9fd;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      box-shadow: 0px -1px 0px 1px #0000001f;
    }
  
    .tabs .tab .happybox-button{
      width: 100%;
      position: relative;
      font-weight: 400;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  
    .tabs .selected .happybox-button{
      font-weight: 700;
    }
  
    .tabs .tab .arrow.down{
      display: none;
    }
  
    .tabs .tab .subtitle{
      font-size: 0.8vw;
      position: absolute;
      top: 28.5%;
      right: 10%;
    }
  
    .tabs .tab.selected .subtitle{
      display: none;
    }
  
    .tabs .tab.selected .arrow.down{
      display: inline-block;
      right: 10%;
      top: 40%;
      position: absolute;
    }
  
    .products-inner-container{
      width: 100%;
      padding: 5% 0;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 30px 2%;
      background-color: #f8f9fd;
    }
  
    .selected .circle.remove{
      display: flex;
    }
  
    .circle.remove{
      display: none;
      align-items: center;
      justify-content: center;
      position: absolute;
      font-size: 2vw;
      width: 1.5vw;
      height: 1.5vw;
      border-radius: 50%;
      background-color: white;
      color: #0f0c38;
      top: -0.75vw;
      right: -0.75vw;
      padding: unset !important;
      z-index: 3;
      line-height: 1;
    }
  
    .circle.remove span{
      margin-bottom: 10%;
    }
  
    .arrow {
      border: solid black;
      border-width: 0 1px 1px 0;
      display: inline-block;
      padding: 2px;
      height: 0px;
      transition: all 0.5s;
      cursor: pointer;
  }
  
  .arrow.up {
      transform: rotate(-135deg);
      -webkit-transform: rotate(-135deg);
  }
  
  .arrow.down {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
  }
  
  .main-badge{
    background-color: white;
    position: absolute;
    top: 2%;
    left: 2%;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1% 3%;
    font-size: 1.1vw;
    font-weight: bold;
    color: #5981d9;
  }
  
  .capacity-overlay{
    color: #5a3089;
    font-size: 1.3vw;
    font-weight: bold;
  }
  
  .bundle-instructions{
    font-size: 1.3vw;
  }
  
  .disabled{
    opacity: 0.6;
  }
  
  .custom-header{
    width: 100%;
    margin-bottom: -6%;
  }
  
  @media only screen and (min-width: 768px){
    .tabs.sticky{
      padding-top: 1px;
      background-color: white;
    }
  
    .tabs.sticky.hasTicker{
      padding-top: 51px;
    }
    
    .tabs.sticky .selected{
      background-color: unset;
      box-shadow: unset;
    }
  
    .tabs.sticky .selected .happybox-button{
      background-color: #E0E5F3;
    }
  }
  
  
    @media only screen and (max-device-width: 767px){
      .desktop-flex{
        display: none;
      }
  
      .desktop{
        display: none;
      }
  
      .mobile{
        display: block;
      }
  
      .wiggle img{
        width: 100%;
        left: unset;
      }
      
      .gift-choice-page .header .title{
        font-size: 8vw;
      }
  
      .gift-choice-page .main-container .main-title{
        font-size: 8vw;
      }
  
      .gift-choice-page .main-container .main-subtitle{
        font-size: 3.5vw;
        padding: 0% 10%;
        font-weight: 500;
      }
  
      .product-container {
        width: 47%;
        margin-bottom: 5%;
      }
  
      .happybox-button.orange{
        font-size: 3.5vw;
        width: 100%;
        margin-top: 5%;
      }
  
      .happybox-button.white, .happybox-button.purple,.happybox-button.yellow,.happybox-button.green{
        font-size: 3.5vw;
      }
  
      .next-step{
        font-size: 5vw;
        margin: 5% 0%;
      }
  
      .continue-container{
          width: 100%;
          background-color: white;
          display: flex;
      }
  
      .continue-container.sticky{
        position: fixed;
        bottom: 0%;
        left: 0;
        padding: 5%;
        border-top: 1px solid black;
        align-items: center;
        justify-content: center;
      }
  
      .continue-container button{
        font-size: 3.5vw;
        width: 100%;
        padding: 2% !important;
        border: unset !important;
      }
  
      .gifting-header{
        justify-content: center;
      }
  
      .header-step{
        width: 50%;
      }
  
      .header-step .title{
        font-size: 3vw;
      }
  
      .header-step .circle{
        width: 4vw;
        height: 4vw;
      }
  
      .header-line{
        bottom: 33%;
      }
  
      .hover-container,.product-container button{
        display: none;
      }
  
      .product-container .product-title{
        font-size: 3vw;
      }
  
      .products-listing{
        padding: 5%;
        gap: unset;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        margin-top: 0.5%
      }
  
      .gift-choice-page .header img{
        width: 70%;
      }
  
      .product-image-container .info{
        width: 15%;
        position: absolute;
        right: 5%;
      }
  
      .loading-container p{
        font-size: 3vw;
        text-align: center;
      }
  
      .tabs{
        padding: 0% 5%;
        overflow-x: scroll;
        gap: 10px;
        justify-content: space-around;
        background-color: white
      }
  
      .tabs .tab{
        width: auto;
        flex-shrink: 0;
        padding: 2% 0%;
      }
  
      .tabs .selected{
        background-color: unset;
        border: unset;
        border-radius: unset;
        box-shadow: unset;
        border-bottom: 2px solid #7d1deb;
      }
  
      .tabs .tab .happybox-button{
        background-color: unset;
        padding: unset;
        border: unset;
        border-radius: unset;
        display: flex;
        align-items: center;
        gap: 5px;
      }
  
      .tabs .tab .subtitle{
        display: none;
      }
  
      .tabs .tab.selected .arrow.down{
        position: static;
        border: solid #7d1deb;
        border-width: 0 2px 2px 0;
      }
  
      .tabs .selected .happybox-button span{
        color: #7d1deb;
      }
  
      .selected .circle.remove{
        display: none;
      }
      .capacity-overlay{
        font-size: 3.5vw;
        text-align: center;
      }
  
      .custom-header{
        margin: unset
      }
  
      .ticker{
        height: 60px;
      }
  
      .tabs.sticky.hasTicker{
        padding-top: 61px;
      }
    }
    
  </style>